import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import GrohmannFooterCopy from './Grohmann/index';
import messages from './messages';
import { getLocalizeUrl } from '../../utils/common';

const getPrivacyPolicyLink = (locale = 'en_us') => {
  const localeNormalized = locale.replace('-', '_').toLowerCase();
  const links = {
    de_at:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_de-DE',
    de_ch:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_de-DE',
    de_de:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_de-DE',
    de_lu:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_de-DE',
    es_es:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_es-ES',
    es_mx:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_es-ES',
    es_pr:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_es-ES',
    fr_be:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_fr-FR',
    fr_ca:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_fr-FR',
    fr_ch:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_fr-FR',
    fr_fr:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_fr-FR',
    fr_lu:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_fr-FR',
    he_il:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_he-IL',
    it_ch:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_it-IT',
    it_it:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_it-IT',
    ko_kr:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_ko-KR',
    nl_be:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_nl-NL',
    nl_nl:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_nl-NL',
    no_no:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_no-NO',
    zh_cn:
      'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28CN%29_cn-CN',
    tr_tr:
      'https://digitalassets.tesla.com/discovery-tesla-com/image/upload/TR-Tesla-Talent-Privacy-Notice.pdf',
  };

  if (links[localeNormalized]) {
    return links[localeNormalized];
  }

  const globalLocales = ['en_us', 'en_ca', 'en_pr'];
  if (globalLocales.includes(localeNormalized)) {
    return 'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29';
  }

  return 'https://digitalassets.tesla.com/tesla-contents/image/upload/Tesla-Talent-Privacy-Notice-%28Global%29_en';
};

const FooterCopy = () => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const isGrohmannSite = useSelector((state) => state.app.isGrohmannSite);
  const flatLocale = locale.replace('-', '_');
  const equalOpportunityOne = ['zh-TW'].includes(locale)
    ? formatMessage(messages.EqualOpportunityOneAlternative)
    : formatMessage(messages.EqualOpportunityOne);

  if (isGrohmannSite) {
    return <GrohmannFooterCopy />;
  }

  const privacyPolicyLink = getPrivacyPolicyLink(locale);

  if (locale !== 'zh-CN') {
    return (
      <>
        <p>{equalOpportunityOne}</p>
        {/* eslint-disable-next-line react/no-danger */}
        <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.EqualOpportunityTwo) }} />
        {/* eslint-disable-next-line react/no-danger */}
        <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.EqualOpportunityThree) }} />
        {!!privacyPolicyLink && (
          <p
            /* eslint-disable-next-line react/no-danger */
            dangerouslySetInnerHTML={{
              __html: formatMessage(messages.PrivacyLocal, {
                link: `<a rel="noreferrer" href="${privacyPolicyLink}" target="_blank" class="tds-link">
                    ${formatMessage(messages.PrivacyLocalLinkText)}
                  </a>`,
              }),
            }}
          />
        )}
        {!privacyPolicyLink && (
          /* eslint-disable-next-line react/no-danger */
          <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.PrivacyOne) }} />
        )}
      </>
    );
  }

  return (
    <div>
      <h3>{formatMessage(messages.AboutTeslaHeader)}</h3>
      <p>{formatMessage(messages.AboutTeslaOne)}</p>
      <p>{formatMessage(messages.AboutTeslaTwo)}</p>
      <p>{formatMessage(messages.AboutTeslaThree)}</p>
      <p>
        <a href={getLocalizeUrl('/about', flatLocale)} target="_blank" rel="noopener noreferrer">
          {formatMessage(messages.LearnMore)}
        </a>
      </p>
      <p>{equalOpportunityOne}</p>
    </div>
  );
};

export default FooterCopy;
